<template>
	<div class="wrap">
		<div class="center u-flex">
			<span class="title poniter" @click="go_home">千村调查数据平台</span>
			<div class="u-flex u-row-between u-flex-1">
				<el-menu mode="horizontal" class="u-font-18" background-color='#7c2326' text-color='#fff'
					active-text-color='#fff' :default-active='defaultActive' router>
					<el-menu-item index='/' class="height70">首页</el-menu-item>
					<el-menu-item index='/content' class="height70">千村动态</el-menu-item>
					<el-submenu index='/achievement'>
						<template slot="title">相关成果</template>
						<el-menu-item :index="'/achievement?type='+item.id" v-for="item in typeList" :key="item.id">
							{{item.name}}</el-menu-item>
					</el-submenu>
					<el-menu-item index='/data' class="height70">调查数据</el-menu-item>
				</el-menu>
				<el-dropdown v-if="$store.state.username">
					<span class="el-dropdown-link" style="height: 100%;display: inline-block;">
						你好，{{$store.state.username}}<i class="el-icon-arrow-down el-icon--right"></i>
					</span>
					<el-dropdown-menu slot="dropdown" class="header-new-drop">
						<el-dropdown-item @click.native='logOut' class="u-font-14">退出</el-dropdown-item>
					</el-dropdown-menu>
				</el-dropdown>

				<el-dropdown v-else>
					<span class="el-dropdown-link u-font-14" style="height: 100%;display: inline-block;">
						未登录<i class="el-icon-arrow-down el-icon--right"></i>
					</span>
					<el-dropdown-menu slot="dropdown" class="header-new-drop login-check">
						<el-dropdown-item @click.native='go_login(1)' class="u-font-14 cm u-flex"
							style='border-bottom: solid 1px #f2efef;'>
							<img src="../assets/login-out-school-red.png">
							<span>校外用户登录</span>
						</el-dropdown-item>
						<el-dropdown-item @click.native='go_login(2)' class="u-font-14 cm u-flex">
							<img src="../assets/login-in-school-red.png">
							<span>校内用户登录</span>
						</el-dropdown-item>
					</el-dropdown-menu>
				</el-dropdown>

				<!-- <span v-else @click="go_login" class="poniter u-font-14">未登录</span> -->
			</div>
		</div>
	</div>
</template>

<script>
	import {
		getToken,
		removeToken,
		setToken,
		removeCookie,
		getCookie
	} from "@/utils/auth";
	export default {
		name: 'Nav',
		data() {
			return {
				defaultActive: '/', //当前激活菜单的 index	
				phone: '',
				typeList: []
			}
		},
		async mounted() {
			// this.phone=this.$store.state.phone||localStorage.getItem('phone')
			const res = await this.$API.getAchievementType({
				pageSize: 100,
				pageNum: 1,
			})
			this.typeList = res.data.results;
		},
		watch: {
			$route: {
				handler(to, from) {
					// console.log(to);
					if (to.path == '/' || to.path == '/content' || to.path == '/data'||to.path=="/achievement") {
						this.defaultActive = to.fullPath
					} else {
						if (from) {
							this.defaultActive = from.path
						} else {
							this.defaultActive = sessionStorage.getItem('route')
						}
					}
					sessionStorage.setItem('route', this.defaultActive)
				},
				immediate: true
			}
		},
		methods: {
			async logOut() {

				if (this.$store.state.is_out_user) {
					await this.$API.logout()
					// 清缓存
					localStorage.clear()
					removeToken();
					this.$Cookies.remove('csrftoken')
					// this.delCookie('sessionid')
					this.$router.replace('/login')
				} else {
					if (getToken()) {
						localStorage.clear()
						removeToken();
						this.$Cookies.remove('csrftoken')
					}
					// 清缓存
					// localStorage.clear()
					// this.delCookie('csrftoken')
					location.href = window.location.origin + "/auth/logout/"
					// this.$API.logout()
					// this.delCookie('csrftoken')
					// this.delCookie('sessionid')
					// window.location.replace('http://10.2.36.97/login-in-school/')
				}
			},
			setCookie(c_name, value, expire) {
				var date = new Date()
				date.setSeconds(date.getSeconds() + expire)
				document.cookie = c_name + "=" + escape(value) + "; expires=" + date.toGMTString()
				//console.log(document.cookie)
			},

			delCookie(c_name) {
				this.setCookie(c_name, "", -1)
			},
			// go_login() {
			// 	location.href = window.location.origin + "/login-in-school/"
			// },
			go_home() {
				if (this.$route.path != '/') {
					this.$router.replace('/')
				}
			},
			go_login(type) {
				if (type == 1) {
					this.$router.push('/login')
				} else {
					location.href = window.location.origin + "/login-in-school/"
					// location.href = 'http://10.2.36.97' + "/login-in-school/"
				}
			}
		},
	}
</script>

<style lang="less" scoped>
	// 行高70px 一起改!!!!!!!!!!
	.height70 {
		font-size: 20px;
		height: 70px !important;
		line-height: 70px !important;
	}

	.wrap {
		height: 70PX;
		line-height: 70PX;
		background-color: #7c2326;

		.center {
			width: 1000PX;
			margin: 0 auto;
			color: #ffffff !important;

			.el-dropdown-link {
				cursor: pointer;
				color: #fff;
				font-size: 14px;
			}

			.el-icon-arrow-down {
				font-size: 12px;
			}

			.title {
				margin-right: 120px;
				font-size: 30px;
			}
		}
	}

	.login-check {
		padding: 0 12px !important;

		.el-dropdown-menu__item {
			padding: 0 !important;
		}

		img {
			width: 14px;
			height: 14px;
			margin-right: 8px;
		}
	}
</style>
<style lang="less">
	.el-submenu{
		.el-menu-item {
			font-size: 16px !important;
			height: 40px !important;
			line-height: 40px !important;
		}
	}
	.el-submenu__title{
		font-size: 20px !important;
		height: 70px !important;
		line-height: 70px !important;
	}
	.el-submenu__title i {
	    color: #fff !important;
	}
	.header-new-drop li:hover {
		background-color: #fff !important;
		color: #7c2326 !important;
	}
</style>
